var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDayClaimed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 19,
    viewBox: "0 0 74 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55866 18.8L0.2 11.9705V0.2H73.8V11.9705L67.4413 18.8H52.0848H21.9152H6.55866Z",
    fill: "url(#paint0_linear_2994_2332)",
    stroke: "#E3931B",
    strokeWidth: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2994_2332",
    x1: 37,
    y1: 46.6213,
    x2: 37,
    y2: -51.4115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3931B",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26253F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDayClaimed);
export default __webpack_public_path__ + "static/media/iconDayClaimed.69cb761de5f51adafeb6d531c97d13a0.svg";
export { ForwardRef as ReactComponent };